export default "__VITE_ASSET__BDGAkFcg__"